import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './http-services/authservice.service';
import { lastValueFrom, Subject } from 'rxjs';
import { UserModel } from '../interface/dto';
import { environment as env } from 'src/environments/environment';
import { TableParams } from '../components/grid/TableParams';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient, private auth: AuthService) { }
    reloadGrid = new Subject<any>();
  UserId: Subject<number> = new Subject();
  private _selectAll: boolean = false;
  configureHeaders() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('Authorization', `Bearer ${this.auth.token}`);
    return headers;
  }

  get selectedUserIds() {
    if (this.selectedUsers == null || this.selectedUsers.length === 0) {
      return [];
    }
    return this.selectedUsers.map(x => x.id);
  }
  public get selectAll(): boolean {
    return this._selectAll;
  }
  public set selectAll(value: boolean) {
    this._selectAll = value;
  }
  setSelectedUser(Users: UserModel[]) {
    localStorage.setItem("selectedUsers", JSON.stringify(Users));
  }
  get selectedUsers() {
    return JSON.parse(localStorage.getItem("selectedUsers")) as UserModel[];
  }


   async getUsers(tableParam: TableParams) {
    return await lastValueFrom(this.httpClient.patch(
      `${env.apiURL}user/`,
      tableParam, { headers: this.configureHeaders() }
    ), { defaultValue: [] });
   }
  async createUser(userData: UserModel) {
    return this.httpClient.post(`${env.apiURL}user/`, userData, { headers: this.configureHeaders() }).toPromise();
  }

  async updateUser(userData: UserModel) {
    return this.httpClient.put(`${env.apiURL}user/`, userData, { headers: this.configureHeaders() }).toPromise();
  }


  async deleteUser(userIds) {
    return this.httpClient.delete(`${env.apiURL}user?${userIds}`, { headers: this.configureHeaders() }).toPromise();
  }

}
